// Curated short list of IANA timezones offered in the profile selector.
// Order: North America first (most common for this app), then UTC, then a
// thin slice of internationals. Extend as needed.
export const TIMEZONE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "America/New_York",    label: "Eastern (US/Canada) — New York" },
  { value: "America/Chicago",     label: "Central (US/Canada) — Chicago" },
  { value: "America/Denver",      label: "Mountain (US/Canada) — Denver" },
  { value: "America/Los_Angeles", label: "Pacific (US/Canada) — Los Angeles" },
  { value: "America/Anchorage",   label: "Alaska — Anchorage" },
  { value: "Pacific/Honolulu",    label: "Hawaii — Honolulu" },
  { value: "UTC",                 label: "UTC" },
  { value: "Europe/London",       label: "London" },
  { value: "Europe/Paris",        label: "Paris / Berlin" },
  { value: "Asia/Tokyo",          label: "Tokyo" },
  { value: "Asia/Singapore",      label: "Singapore" },
  { value: "Australia/Sydney",    label: "Sydney" },
]
